package com.eladfinish.bible.contest.screens.names.api

import com.eladfinish.bible.contest.currentMilliseconds
import com.eladfinish.bible.contest.network.DefaultApiResult
import com.eladfinish.bible.contest.network.GithubURL
import com.eladfinish.bible.contest.network.apiResultUTF8
import com.eladfinish.bible.contest.network.spreadsheet.GoogleSheetContent
import io.ktor.client.HttpClient
import io.ktor.client.request.get

interface NamesGithubApi {
    suspend fun getNamesResults(gender: String, letter: String): DefaultApiResult<List<GoogleSheetContent>>
}

class NamesGithubApiImpl(
    private val client: HttpClient,
) : NamesGithubApi {

    override suspend fun getNamesResults(gender: String, letter: String): DefaultApiResult<List<GoogleSheetContent>> = apiResultUTF8 {
        client.get(GithubURL.nameUrl(gender = gender, letter = letter, cacheBuster = currentMilliseconds))
    }

}
